<script>
import Layout from "../../layouts/main";
import BannerApi from "@/services/banner-api";
import NewsLetterApi from "@/services/newsLetter-api";
import SpecialGroupApi from "@/services/specialGroup-api";
import SettingsApi from "@/services/settings-api";  


export default {
  page: {
    title: "Boutique en ligne de mode en Tunisie",
    titleTemplate: 'HA | %s',
    meta: [
      { vmid: 'description',        name: 'description',            content: 'Bienvenue sur HA, votre boutique en ligne de prêt-à-porter et accessoires pour femme, homme, fille et garçon. Découvrez nos nouvelles collections et commandez avec livraison en Tunisie.' },
      { vmid: 'og:title',           property: 'og:title',           content: 'HA | Boutique en ligne de mode en Tunisie' },
      { vmid: 'og:description',     property: 'og:description',     content: 'Bienvenue sur HA, votre boutique en ligne de prêt-à-porter et accessoires pour femme, homme, fille et garçon. Découvrez nos nouvelles collections et commandez avec livraison en Tunisie.' },
      { vmid: 'og:url',             property: 'og:url',             content: 'https://ha.com.tn/' },
      { vmid: 'twitter:title',      name: 'twitter:title',          content: 'HA | Boutique en ligne de mode en Tunisie' },
      { vmid: 'twitter:description',name: 'twitter:description',    content: 'Bienvenue sur HA, votre boutique en ligne de prêt-à-porter et accessoires pour femme, homme, fille et garçon. Découvrez nos nouvelles collections et commandez avec livraison en Tunisie.' },
    ],
    link: [{ vmid: 'canonical', rel: 'canonical', href: 'https://ha.com.tn/' }],
    script: [
      {
        id: 'ldjson-organization',
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'HA',
          url: 'https://ha.com.tn',
          logo: 'https://ha.com.tn/img/logo.png',
          sameAs: [],
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            availableLanguage: ['French', 'Arabic']
          }
        })
      },
      {
        id: 'ldjson-website',
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'HA',
          url: 'https://ha.com.tn',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://ha.com.tn/catalogue?reference={search_term_string}',
            'query-input': 'required name=search_term_string'
          }
        })
      }
    ],
    __dangerouslyDisableSanitizersByTagID: {
      'ldjson-organization': ['innerHTML'],
      'ldjson-website':      ['innerHTML']
    }
  },
  components: { Layout },
  
  computed: {
    windowWidth() {
      return window.innerWidth;
    },
  },

  data() {
    return {

      pagemodel: {currentPage : 1, perPage : 6, totalRows: 0},

      itemSpecialGroup : null ,
      specialGroup:{id:null},
      selectedSpecialGroup: null,

      selectedItem:{id:null},
      settingsDashboard:{image1:null , image2:null , image3:null , video:null , outlet:null} ,
      settingsBanner:null ,
      isLoading:false ,
    

      email: null,

      bannerList: [],
      isBannerTableBusy: false,

      nowAvailableItems: [],
      newSuppliers: [],
      newItems: [],

      topItems:[],
      isGetTopItemsStarting: false,

      newAccountCompanyName: null,
      newAccountCompanyPhone: null,
      showSuccessMessage: false ,
      showErrorMessage: false ,

      videoKey: 0,

      hdImageLoaded: {},

      homeLogos:["logo-bosch", "logo-cerva", "logo-ridgid", "logo-esab", "logo-facom", "logo-defender", "logo-tractel", "logo-3M", "logo-climax"],

      settings: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "edgeFriction": 0.35,
          "infinite": true,
          "speed": 1000,
          "autoplay": true,
          "slidesToShow": 1,
          "slidesToScroll": 1,

          "fade": true,
          "arrows": false,

          //"vertical": true,
          //"verticalSwiping": true
        },


        settingsNewSuppliersBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 5000,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 5,
        },

        settingsNewItemBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 4000,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 1,
          "arrows": true,


          "responsive": [
              {
                "breakpoint": 1024,
                "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 600,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 480,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              }
            ]


        }
    };
  },

  mounted() {

    Promise.all([
      this.findBanner(this.windowWidth),
      this.getSettingsBanner(),
      this.findAllSpecialGroup(),
      this.getSettingsDashboard(),
    ]);

  },

  methods: {

    loadNextSpecialGroup(event, index) {
        event.stopPropagation();

        const nextIndex = (index + 1) % this.specialGroup.length;
        this.getItemSpecialGroup(this.specialGroup[nextIndex]);
    },

    loadPreviousSpecialGroup(event, index) {
            event.stopPropagation();

            const previousIndex = (index - 1 + this.specialGroup.length) % this.specialGroup.length;
            this.getItemSpecialGroup(this.specialGroup[previousIndex]);
        },

    onHdImageLoad(image) {
            if (!image) {
                return;
            }
            this.$set(this.hdImageLoaded, image, true);
    },

    addToNewsLetter(){
      if(this.email == null){
        return
      }
      NewsLetterApi.addToNewsLetter(this.email).then(
        (result)=>{
          if(result){
            this.showSuccessMessage = result 
            setTimeout(() => {this.showSuccessMessage = false; }, 4000);
          }else{
            this.showErrorMessage = true
            setTimeout(() => {this.showErrorMessage = false; }, 4000);
          }
        }
      )
    },

    getSettingsBanner(){
      const itemSectionId = this.$store.state.mainSectionId
      return SettingsApi.getSettingsBanner(itemSectionId)
      .then(result => {
      if(result){
        this.settingsBanner= result
      }
      })
      },


    getSettingsDashboard(){
      this.videoKey = 0
      const itemSectionId = this.$store.state.mainSectionId
      return SettingsApi.getSettingsDashboard(itemSectionId)
      .then(result => {
        if(result){
          this.settingsDashboard= result
          this.videoKey += 1 
        }
      })
    },

    isSelected(specialGroupIndex) {
        return this.selectedItem.id === specialGroupIndex;
    },

    findAllSpecialGroup(){

      const itemSectionId = this.$store.state.mainSectionId
      return SpecialGroupApi.findAllSpecialGroup(itemSectionId, 3)
      .then(result => {
        if(result){
          this.specialGroup= result,
          this.getItemSpecialGroup(result[0] )
        }
      })
    },


    getItemSpecialGroup(specialGroup){

      if (!specialGroup) {
        return;
      }

      this.isLoading = true 

      const itemSectionId = this.$store.state.mainSectionId
      SpecialGroupApi.getItemSpecialGroup(this.pagemodel.currentPage, this.pagemodel.perPage , specialGroup.id, itemSectionId)
      .then(result => {
        if(result){
          this.itemSpecialGroup= result.list
          this.pagemodel.totalRows = result.total;
          this.pagemodel.currentPage = result.page;
          this.pagemodel.perPage = result.pageSize;
          this.pagemodel.pageSize = result.pageSize;
          this.selectedItem.id = specialGroup.id;
          this.isLoading = false 

          this.selectedSpecialGroup = specialGroup;
        }

      })
    },

    findBanner(windowWidth) {
      const itemSectionId = this.$store.state.mainSectionId
      this.isBannerTableBusy = true;
      return BannerApi.getBanners(windowWidth , itemSectionId).then((result) => {
        this.bannerList = result;
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    goToURL(url) {
        window.location.href = url;
    }

  },

  watch: {
        '$store.state.mainSectionId': {
            handler() {
              
              this.getSettingsDashboard();
              this.findAllSpecialGroup();
              this.getSettingsBanner();
              this.findBanner(this.windowWidth)
              //this.getSettingsBanner();

            },
            deep: true,
        },
  },
};
</script>


<style>

@media (min-width: 1200px) {
  .newsletter-padding {
    padding:55px;
  }
}

@media (max-width: 1200px) {
  .newsletter-padding {
    padding:20px;
  }
}

@media (min-width: 1200px) {
.right-light-border {
  border-right: 1px solid #EAEAEA; 
}
}

.special-group-img {
  display: block;
  margin-left: auto;
  margin-right: auto;  
  border-radius: 7px;
}

.cardInner {
    position: relative;
    height: 100%;
    width: 100%;
    top: 0%;
    right: 0%;
    bottom: 15.65%;
    left: 0%;

    overflow: hidden;
}

.trending-content a span.img-marq {
    display: inline-block;
    line-height: 1;
    margin-right: 15px;
    position: relative;
}

.slick-arrow:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}



.newitems .simplebar-scrollbar::before {
  background-color: #5cb45b;
}

.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}


carousel-item .active .img-fluid {
  border-radius:500px !important;
}

@media all and (max-width: 1199px) {
    .mobile-padding {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }

  /* .carousel-caption {
  position: absolute;
  top: 60%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
} */

 .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  z-index: 1;
  pointer-events: none;
} 


.carousel-caption {
  position: absolute;
  padding-left: 30px;
  top: 50%;
  left: 0;
  /*right: 50%;*/
  transform: translateY(-50%);
  z-index: 2;
}
/* Offset for fixed topbar: navbar (~68px) + black announcement bar (~32px) */
.main-banner-row {
  margin-top: 70px;
}

@media (max-width: 767px) {
  .main-banner-row {
    margin-top: 105px;
  }
}

.banner-image {
  position: relative;
  z-index: 0;
  width: 100%;
  height: auto;
  display: block;
}

@media (max-width: 767px) {
  .banner-image {
    height: auto;
    max-height: none;
    object-fit: contain;
  }
}

/* .footer-default {
    background: #f7f6f6 url('~@/assets/images/footer-bg.png') no-repeat right 35px;
}  */

.footer-default {
  background: none;
}

@media (min-width: 992px) {
  .footer-default {
    /*background: #f7f6f6 url('~@/assets/images/footer-bg.png') no-repeat right 35px;*/
  }
}


/* group-12-height */

@media (max-width: 400px) {
    .group-12-height {
        height: 700px; 
    }
}

@media (max-width: 555px) and (min-width: 401px) {
     .group-12-height {
        height: 720px;
    }
}

@media (max-width: 1198px) and (min-width: 556px) {
     .group-12-height {
        height: 790px;
    }
}

@media (min-width: 1199px) {
    .group-12-height {
        height: 790px; 
    }
}




/* group-2-height */

@media (max-width: 400px) {
    .group-2-height {
        height: 326px; 
    }
}

@media (max-width: 555px) and (min-width: 401px) {
     .group-2-height {
        height: 340px;
    }
}

@media (max-width: 1198px) and (min-width: 556px) {
     .group-2-height {
        height: 379px;
    }
}

@media (min-width: 1199px) {
    .group-2-height {
        height: 379px; 
    }
}

@media (max-width: 1199px) {
  .group-name {
    font-size: 20px;
  }
}

@media (min-width: 1200px) {
  .group-name {
    font-size: 34px;
  }
}


/* group-1-height */

@media (max-width: 400px) {
    .group-1-height {
        height: 400px; 
    }
}

@media (max-width: 555px) and (min-width: 401px) {
     .group-1-height {
        height: 570px;
    }
}

@media (max-width: 1198px) and (min-width: 556px) {
     .group-1-height {
        height: 790px;
    }
}

@media (min-width: 1199px) {
    .group-1-height {
        height: 790px; 
    }
}

</style>

<template>
  <Layout>

    <!-- sr-only H1 for SEO: visible to crawlers, zero visual impact -->
    <h1 class="sr-only">HA - Boutique en ligne de prêt-à-porter et accessoires pour femme, homme, fille et garçon en Tunisie</h1>

        <!-- Main Banners -->
        <div class="row pt-xl-0 main-banner-row">
          <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
          <div class="col-12" v-if="bannerList && bannerList.length" >
            <div class="p-0" >
                <b-carousel
                  style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%); z-index: 8 !important;"
                    :interval="6000"
                    

                    :controls="false"
                    :indicators="false"
                    :no-hover-pause="false"
                    :no-touch="false"
                    :fade="true">

                    <b-carousel-slide class="bg-light"
                              img-blank img-alt="Blank Image "
                              v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                      <!-- <p class="text-secondary">
                        caption="Restez à l'écoute!" 
                        Les publicitées seront disponibles prochainement
                      </p> -->

                    </b-carousel-slide> 

                    <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                      <template #img>
                        <!-- <div class="overlay"></div> -->
                        <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image">
                      </template>
                    

                      <div>

                      

                      </div>

                    </b-carousel-slide>
                    <div v-if="settingsBanner" class="carousel-caption text-left d-none d-sm-block">
                        <h5 v-if="settingsBanner && this.settingsBanner.bannerTitle1" class="font-weight-bold font-size-16" :style="{ color: settingsBanner.bannerAllTextColor || '#fff' }">{{ this.settingsBanner.bannerTitle1 }}</h5>
                        <h3  :style="{
                              fontSize: '36px',
                              fontStyle: 'normal',
                              fontWeight: 500,
                              lineHeight: '58px', /* 107.407% */
                              letterSpacing: '-1px',
                              color: settingsBanner.bannerAllTextColor || '#fff'
                            }">{{ this.settingsBanner.bannerTitle2 }}</h3>
                        <p class="font-size-18" :style="{ color: settingsBanner.bannerAllTextColor || '#fff' }">{{ this.settingsBanner.bannerDescription1 }}</p>

                        <a v-if="settingsBanner.bannerButton1" :href="settingsBanner.bannerButton1">
                          <button
                              type="button"
                              :style="{padding: '10px 26px',
                                      color: settingsBanner.bannerButtonTextColor1 || '#fff',
                                      backgroundColor: settingsBanner.bannerButtonColor1 || '#000'}"
                              class="btn font-weight-bold font-size-18">
                                {{ settingsBanner.bannerButtonText1 || 'Voir la collection' }}
                          </button>                        
                        </a>                          
                      
                      </div>
                    
                 
                </b-carousel>



            </div>
          </div>


        </div>


        <div class="row pt-3 pt-sm-0 bg-light" v-if="this.settingsBanner && (this.settingsBanner.bannerTitle1  || this.settingsBanner.bannerTitle2 || settingsBanner.bannerButton1)">
          <div class="col-12 ">
              <div v-if="settingsBanner"  :class="this.settingsBanner.bannerTitle1  || this.settingsBanner.bannerTitle2 || settingsBanner.bannerButton1  ? 'text-left d-sm-none p-4 p-sm-0' : 'text-left d-sm-none p-0'">
                <h5 class="font-weight-bold font-size-16 text-dark" >{{ this.settingsBanner.bannerTitle1 }}</h5>
                <h3  :style="{
                      fontSize: '36px',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      lineHeight: '58px', /* 107.407% */
                      letterSpacing: '-1px',
                      color: settingsBanner.bannerAllTextColor
                    }">{{ this.settingsBanner.bannerTitle2 }}</h3>
                <p class="font-size-18 text-dark" >{{ this.settingsBanner.bannerDescription1 }}</p>

                <a v-if="settingsBanner.bannerButton1" :href="settingsBanner.bannerButton1">
                  <b-button
                      type="button"
                      variant="primary"
                      class="btn font-weight-bold font-size-18">
                        {{ settingsBanner.bannerButtonText1 || 'Voir la collection' }}
                  </b-button>
                </a>                          
              
              </div>
          </div>
        </div>
  
    
    <div class="">

      <!-- CATEGORIES -->
      <div  v-if="settingsDashboard.itemSubGroupName1 && settingsDashboard.image1 && settingsDashboard.itemSubGroupName2 && settingsDashboard.image2 &&
                  settingsDashboard.itemSubGroupName3 && settingsDashboard.image3" 
            class="row mt-4 pt-md-4 pb-4 mb-4 p-0 p-md-4 home-page-80-width"  style="border-radius:10px; margin-bottom:50px !important;">

            <!-- GROUP 1 -->
            <div class="col-12 col-md-6 pr-md-4 bg-light group-1-height" :style="{ backgroundImage: `url('/api/image/get/uncompressed/${settingsDashboard.image1}')`, 
                  backgroundRepeat: 'no-repeat', 
                  backgroundSize: 'cover',
                  backgroundPosition: 'center', cursor: 'pointer' }" @click="goToURL(settingsDashboard.itemSubGroupUrl1)" >

                <h5 class="text-white mt-4 ml-4 font-weight-bold group-name" style="
                  font-style: normal;
                  font-weight: 500;
                  line-height: 38px; /* 111.765% */
                  letter-spacing: -0.6px;"
                  >{{settingsDashboard.itemSubGroupName1}}</h5>

                <a v-if="settingsDashboard.itemSubGroupUrl1" :href="settingsDashboard.itemSubGroupUrl1">
                  <span class="pt-2 ml-4 text-white" style="border-bottom: 1px solid var(--white-900, #FFFFFF);">Découvrir</span>
                </a>

            </div>
            
            <div class="col-12 col-md-6 pl-md-4 group-12-height" > 

              <!-- GROUP 2 -->
              <div class="row m-0 mt-4 mt-md-0 pb-0 bg-light group-2-height">

                  <div class="col-12" :style="{ backgroundImage: `url('/api/image/get/uncompressed/${settingsDashboard.image2}')`, 
                       backgroundRepeat: 'no-repeat', 
                  backgroundSize: 'cover',
                  backgroundPosition: 'center', cursor: 'pointer' }" @click="goToURL(settingsDashboard.itemSubGroupUrl2)"  >
                  

                    <div style="position: absolute;
                        bottom: 30px;text-align:left;">

                                <h5 class="text-white mt-4 ml-4 font-weight-bold group-name" style="
                            font-style: normal;
                            font-weight: 500;
                            line-height: 38px; /* 111.765% */
                            letter-spacing: -0.6px;">{{settingsDashboard.itemSubGroupName2}}</h5>

                          <a v-if="settingsDashboard.itemSubGroupUrl2" :href="settingsDashboard.itemSubGroupUrl2">
                              <span class="pt-2 ml-4 text-white" style="border-bottom: 1px solid var(--white-900, #FFFFFF);">Découvrir</span>
                          </a>
                    </div>

                   

                  </div>

              </div>

               <!-- GROUP 3 -->
              <div class="row mt-md-2  pl-md-4 "  style="    position: absolute; position: absolute; bottom: 0;
                      width: 100%;text-align: center;right: 0;">

                  <div class="col-12 bg-light group-2-height" :style="{ backgroundImage: `url('/api/image/get/uncompressed/${settingsDashboard.image3}')`, 
                     backgroundRepeat: 'no-repeat', 
                  backgroundSize: 'cover',
                  backgroundPosition: 'center', cursor: 'pointer' }"  @click="goToURL(settingsDashboard.itemSubGroupUrl3)">

                    <div style="position: absolute;
                        bottom: 30px;text-align:left;">

                                <h5 class="text-white mt-4 ml-4 font-weight-bold group-name" style="
                            font-style: normal;
                            font-weight: 500;
                            line-height: 38px; /* 111.765% */
                            letter-spacing: -0.6px;">{{settingsDashboard.itemSubGroupName3}}</h5>

                          <a v-if="settingsDashboard.itemSubGroupUrl3" :href="settingsDashboard.itemSubGroupUrl3">
                            <span class="pt-2 ml-4 text-white" style="border-bottom: 1px solid var(--white-900, #FFFFFF);">Découvrir</span>
                          </a>
                    </div>

                  </div>

              </div>


            </div>
          
        
        </div>
      <!-- END CATEGORIES -->
      
        <!-- MEILLEURES VENTES -->
         <div class="row mt-4 pt-xl-4 pb-4 mb-4 p-0 p-md-4 home-page-80-width"  style="border-radius:10px; margin-bottom:50px !important;">

              
              <div class="col-12">

                  <div class="row pb-4">
                    
                      <div class="col-3 d-none d-xl-inline"/>
                      <div class="col-12 col-xl-6">
                        <div v-if="specialGroup" class="row">
                            <div v-for="(item, index) in specialGroup" :key="index" class="col-12 col-lg-4 text-center">
                                <div v-if="item && item.id" @click="getItemSpecialGroup(item)" class="text-dark text-center" 
                                    :class="isSelected(item.id) ? 'font-weight-bold' : 'd-none d-lg-block'" 
                                    :style="isSelected(item.id) ? 'border-bottom: 2px solid var(--black-900, #121212);' : ''" 
                                    style="letter-spacing: 1px; font-size: 22px; font-style: normal; line-height: 34px; cursor: pointer; min-width: 230px;">


                                    <div class="row">
                                      <div class="col-1 text-left d-lg-none">
                                        <b-button  variant="outline" class="pr-2 pl-0" style="cursor: pointer;"  @click="loadPreviousSpecialGroup($event, index)" >   
                                          <img   alt=""  width="25px"  src="@/assets/icons/fi-rr-angle-small-left.svg"  />  
                                        </b-button> 
                                      </div>
                                      <div class="col-10 col-lg-12 text-center">
                                        {{ item.name }}
                                      </div>
                                      <div class="col-1 text-right d-lg-none">
                                        <b-button  variant="outline" class="pr-0 pl-2" style="cursor: pointer;"  @click="loadNextSpecialGroup($event, index)" >   
                                          <img   alt=""  width="25px"  src="@/assets/icons/fi-rr-angle-small-right.svg"  />  
                                        </b-button> 
                                      </div>
                                    </div>
                                   

                                   
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                  </div>



                  <div v-if="this.itemSpecialGroup" class="row mt-4 pb-1 pb-lg-4">

                    <div v-for="(data) in itemSpecialGroup" :key="data.id" class="col-6 col-sm-6  col-lg-4 mb-4">

                        <a class="bg-info cardInner" :href="'/catalogue' + data.url">
                            <img v-show="hdImageLoaded[data.image]" @load="onHdImageLoad(data.image)" class="mb-2 special-group-img" :src="'api/image/get/product/' + data.image" width="90%" height="auto" loading="lazy" />
                            <img v-show="!hdImageLoaded[data.image]" class="mb-2 special-group-img" :src="'api/image/get/product/small/' + data.image" width="90%" height="auto" loading="lazy" />

                            <div class="text-center">
                              <span class="text-dark font-size-16" style="font-weight: 500; line-height: 28px; letter-spacing: -0.4px;" >{{data.title}}</span>
                            </div>
                            <div class="text-center">
                              <div class="col-12 price-default font-weight-bold text-center">
                                  <span style="font-size:14px;">{{ data && data.priceDiscounted ? data.priceDiscounted : '' }} </span>
                                  <span v-if="data && data.discount" 
                                      class="ml-1 line-through font-size-12 text-secondary" >{{ data.price }}</span>  
                                  <span v-if="data && data.discount" class="ml-3 discountLabel-max-default" style="white-space: nowrap;">{{ data.discountStr }}</span>
                              </div>
                            </div>
                        </a>
                      
                    </div>
                  </div>
                  <div class="text-center mb-1 mb-lg-4" >
                    <b-spinner v-if="isLoading" large class="mr-0 mr-xl-2" ></b-spinner>

                  </div>




                  <div v-if="this.itemSpecialGroup && this.itemSpecialGroup.length" class="row mt-1 mt-lg-4">
                      <div class="col-12 text-center">
                          <a :href="'/ha/' + selectedSpecialGroup.seoName ">
                            <button  type="button" style="padding: 10px 26px;" class="btn text-white bg-dark font-weight-bold  " > 
                            
                                Charger plus
                            </button>
                          </a>
                      </div>
                  </div>

                  <div v-if="this.itemSpecialGroup && !this.itemSpecialGroup.length" class="row mt-4">
                      <div class="col-12 text-center">
                        <div class="text-warning font-weight-bold">Restez à l'écoute pour de futures nouveautés passionnantes ! </div>
                        <div class="text-warning font-weight-bold"> Revenez bientôt pour découvrir ce que nous avons prévu pour vous.</div>
                      </div>
                  </div>
                
              </div>

        </div>

        <!-- END MEILLEURES VENTES -->

        <!-- HA SERIES -->
        <div v-if="settingsDashboard.video" class="row mt-4 pt-xl-4 pb-4 mb-4 p-0 p-md-4 home-page-80-width"  style="border-radius:10px; margin-bottom:50px !important;">

            <div class="col-12">

                <div class="row mb-4">

                    <div class="col-12 text-center">
                        <!--h3 class="text-dark mb-3" style="font-weight: 500;line-height: 58px; font-size:54px;letter-spacing: -1px;">HA Series®</h3-->
                        <!-- <span class="font-size-18 text-info" style="width:540px; font-style: normal;font-weight: 400;line-height: 30px;">Scrambled it to make a type specimen book.
                        It has survived not only five centuries</span> -->
                    </div>

                </div>

                <div class="row">

                  <div class="col-12">
                    <video  :key="videoKey"  width="100%" height="100%" loop playsinline autoplay muted >
            <source :src="'/api/image/get/'+settingsDashboard.video" type="video/mp4" >
						</video>

                  </div>



                </div>

            </div>

        </div>
        <!-- END HA SERIES -->


        <!-- THE OUTLETS -->
        <div v-if="settingsDashboard.outlet"  class="row mt-4 pt-xl-4 pb-4 mb-4 p-0 p-md-4 home-page-80-width"  style="border-radius:10px; margin-bottom:50px !important;">

            <div class="col-12">

                <div class="row mb-4">

                    <div class="col-12 text-center">
                        <h3 class="text-dark mb-3" style="font-weight: 500;line-height: 58px; font-size:54px;letter-spacing: -1px;">The Outlet</h3>
                        <!-- <span class="font-size-18 text-info" style="width:540px; font-style: normal;font-weight: 400;line-height: 30px;">Scrambled it to make a type specimen book.
                        It has survived not only five centuries</span> -->
                    </div>

                </div>

                <div class="row bg-light ">

                  <div class="col-12 text-center">

                    <img class="my-auto text-center" :src="'/api/image/get/'+settingsDashboard.outlet" width="100%" height="auto" loading="lazy"  >
                   
                  </div>



                </div>

            </div>

            </div>
            <!-- END THE OUTLETS -->

            <!-- NEWSLETTER -->
            <div class="row  mt-4 pt-xl-4 pb-4 mb-4 p-0 p-md-4 home-page-80-width"  style="border-radius:10px; margin-bottom:50px !important;">

            <div class="col-12 bg-light newsletter-padding" >


              <div class="row pt-0 pt-4 mb-4">
                  <div class="col-12 text-center">
                      <h3 class="text-dark mb-3" style="font-weight: 500; letter-spacing: -1px;">
                          <div class="d-none d-lg-inline" style="line-height: 40px; font-size: 44px;">
                              Inscrivez-vous maintenant
                          </div>
                          <div class="d-inline d-lg-none" style="line-height: 30px; font-size: 26px;">
                              Inscrivez-vous maintenant
                          </div>
                      </h3>
                      <span class="font-size-18 text-info" style="width: 540px; font-style: normal; font-weight: 400; line-height: 30px;">
                          et bénéficiez de<span class="text-warning font-weight-bold"> 10 % de remise </span> sur votre première commande
                      </span>
                  </div>
              </div>

                <div class="row pt-4 pb-4">

                  <div class="col-3 d-none d-lg-flex" />
                  <div class="col-12 col-lg-6 pb-4 text-center">

                    <b-input-group>
                              <b-form-input v-model="email" placeholder="Votre adresse mail" @keyup.native.enter="addToNewsLetter()"
                              type="email" class="text-dark bg-light font-weight-bold font-size-18 " style="border-left: 0; border-right: 0; border-top: 0;border-bottom: 1px solid #000;border-radius:0px;"
                              ></b-form-input>
                              <template v-slot:append>
                                  <b-button  size="sm" variant="light" @click="addToNewsLetter()"
                                  style="border-left: 0; border-right: 0; border-top: 0;border-bottom: 1px solid #000;border-radius:0px;">
                                  <img class="my-auto text-center" src="@/assets/icons/arrow-right.svg"  >
                                  </b-button>
                              </template>                            
                            </b-input-group>

                   
                  </div>            
                </div>       
                
                <div class="row ">

                  <div class="col-12 text-center">
                      <span v-show="showSuccessMessage" class="text-dark font-weight-bold pt-4 mt-4">   {{$t('homePage.successMessage')}}</span>
                      <span v-show="showErrorMessage" class="text-warning font-weight-bold pt-4 mt-4">{{$t('homePage.errorMessage')}}</span>
                  </div>

                </div>


            </div>

            </div>
            <!-- END NEWSLETTER -->

            <!-- INSTAGRAM tmp disabled following HA request on 21/09/2026 -->
            <div v-if="false" class="row mt-4 pt-xl-4 pb-1 mb-1 p-0 p-md-1 home-page-80-width" >

                <div class="col-12">

                    <div class="row mb-5">

                        <div class="col-12 text-center">
                            <div><span class="font-size-16 text-center text-dark" style="line-height: 26px;">ON Y EST !</span></div>
                            <a href="https://www.instagram.com/ha.hamadiabid/" target="_blank" rel="noopener noreferrer" style="text-decoration: none;">
                              <h3 class="text-dark mt-2 mb-3" style="font-weight: 500;line-height: 44px; font-size:54px;letter-spacing: -1px;">Sur Instagram</h3>
                            </a>
                            <!-- <span class="font-size-18 text-info" style="width:540px; font-style: normal;font-weight: 400;line-height: 30px;">Scrambled it to make a type specimen book.
                            It has survived not only five centuries</span> -->
                        </div>

                    </div>

                    <div class="row ">

                      <div class="col-6 col-md-3 col-lg-3 text-center">
                        <a :href="settingsDashboard.urlImageInstagram1" target="_blank">
                          <img v-if="settingsDashboard.imageInstagramName1" class="my-auto text-center p-0 p-md-4" :src="'/api/image/get/'+settingsDashboard.imageInstagramName1" width="100%" height="auto" loading="lazy"  >
                        </a>
                      </div>

                      <div class="col-6 col-md-3 col-lg-3 text-center">
                        <a :href="settingsDashboard.urlImageInstagram2" target="_blank">
                          <img v-if="settingsDashboard.imageInstagramName2" class="my-auto text-center p-0 p-md-4" :src="'/api/image/get/'+settingsDashboard.imageInstagramName2" width="100%" height="auto" loading="lazy"  >
                        </a>
                      </div>

                      <div class="col-6 col-md-3 col-lg-3 text-center">
                        <a :href="settingsDashboard.urlImageInstagram3" target="_blank">
                          <img v-if="settingsDashboard.imageInstagramName3" class="my-auto text-center p-0 p-md-4" :src="'/api/image/get/'+settingsDashboard.imageInstagramName3" width="100%" height="auto" loading="lazy"  >
                        </a>
                      </div>

                      <div class="col-6 col-md-3 col-lg-3 text-center">
                        <a :href="settingsDashboard.urlImageInstagram4" target="_blank">
                          <img v-if="settingsDashboard.imageInstagramName4" class="my-auto text-center p-0 p-md-4" :src="'/api/image/get/'+settingsDashboard.imageInstagramName4" width="100%" height="auto" loading="lazy"  >
                        </a>
                      </div>



                    </div>

                </div>

            </div>
            <!-- END INSTAGRAM -->

            <!-- FREE DELIVERY -->
            <div class="row mt-1 pt-xl-4 p-0 p-md-4 home-page-80-width" >

                  <div class="col-12 col-sm-6 col-xl-3 text-center d-flex flex-column justify-content-center right-light-border trust-item" >
                    <div class="trust-item-inner">
                      <img src="@/assets/icons/shipping.svg" height="24px" class="trust-icon">
                      <div class="trust-text">
                        <span class="text-dark font-size-18" style="font-weight: 500; line-height: 32px; letter-spacing: -0.4px;">Livraison gratuite</span>
                        <div class="mt-1">
                          <span class="text-secondary" style="font-size: 14px; font-weight: 400; line-height: 22px;">A partir de 150 TND</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-xl-3 text-center d-flex flex-column justify-content-center right-light-border trust-item">
                    <div class="trust-item-inner">
                      <img src="@/assets/icons/thumbs.svg" height="24px" class="trust-icon">
                      <div class="trust-text">
                        <span class="text-dark font-size-18" style="font-weight: 500; line-height: 32px; letter-spacing: -0.4px;">Echange gratuit</span>
                        <div class="mt-1">
                          <span class="text-secondary" style="font-size: 14px; font-weight: 400; line-height: 22px;">En magasin</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-xl-3 text-center d-flex flex-column justify-content-center right-light-border trust-item">
                    <div class="trust-item-inner">
                      <img src="@/assets/icons/Support24.svg" height="24px" class="trust-icon">
                      <div class="trust-text">
                        <span class="text-dark font-size-18" style="font-weight: 500; line-height: 32px; letter-spacing: -0.4px;">Service client</span>
                        <div class="mt-1">
                          <span class="text-secondary" style="font-size: 14px; font-weight: 400; line-height: 22px;">
                            <a class="font-weight-normal text-secondary" href="mailto:Service.client@ha.com.tn">Service.client@ha.com.tn</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-6 col-xl-3 text-center d-flex flex-column justify-content-center trust-item">
                    <div class="trust-item-inner">
                      <img src="@/assets/icons/shield.svg" height="24px" class="trust-icon">
                      <div class="trust-text">
                        <span class="text-dark font-size-18" style="font-weight: 500; line-height: 32px; letter-spacing: -0.4px;">Paiement sécurisé</span>
                        <div class="mt-1">
                          <span class="text-secondary" style="font-size: 14px; font-weight: 400; line-height: 22px;">Par Tunisie-Monétique</span>
                        </div>
                      </div>
                    </div>
                  </div>


                     

                     




              </div>
            <!-- END FREE DELIVERY -->


      

   

        
        

            

        
       
        



        

    
         
       
    
    </div>

  </Layout>
</template>

<style scoped>

/* Trust bar — desktop: icon left, text right */
.trust-item {
  height: 135px;
}

.trust-item-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.trust-text {
  text-align: left;
}

/* Mobile only: icon on top, everything centered */
@media (max-width: 575px) {
  .trust-item {
    height: auto;
    padding: 20px 0;
    border-bottom: 1px solid #eee;
  }
  .trust-item-inner {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  .trust-icon {
    height: 30px !important;
  }
  .trust-text {
    text-align: center;
  }
}

.price-default {
    position: relative;
    font-weight: 600;
    font-family: Inter;
    color: #121212;
    text-align: left;
}

.discountLabel-max-default {

    border-radius: 8px;
    background-color: #ff0000;
    font-size: 10px;
    line-height: 18 px;
    font-weight: bold;
    color: #fff;
    padding: 2px 8px 2px 8px;
}
</style>